import { ExclaimCircleIcon, IconButton, XCloseIcon } from "@minervaproject/fds";
import { useState } from "react";

function OverlayError({ text, hideModal }: { text: string; hideModal?: () => void }) {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;
  return (
    <div
      className="flex fixed top-0 bottom-0 left-0 right-0 items-center justify-center"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.75)", zIndex: 10001 }}
      onClick={() => {
        setIsOpen(false);
        hideModal?.();
      }}
    >
      <div
        className="relative flex"
        style={{
          backgroundColor: "var(--orange-tint-90)",
          gap: "8px",
          borderRadius: "4px",
          padding: "30px 50px",
        }}
      >
        <ExclaimCircleIcon color="orange" mt="2px" size="lg" />
        <div className="body-s text-black">{text}</div>
        <div className="absolute top-0 right-0 p3">
          <IconButton onClick="" name="modal.close" aria-label="Close modal">
            <XCloseIcon size="md" color="blackTint70" />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export { OverlayError };
